var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCaneta(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Elipse_132",
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_editar",
    "data-name": "icon editar",
    transform: "translate(-1682 -424.97)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2024",
    "data-name": "Grupo 2024",
    transform: "translate(1690.645 430.97)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -8.64, -6)",
    filter: "url(#Elipse_132)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_132-2",
    "data-name": "Elipse 132",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(9 6)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "noun_edit_4150435",
    transform: "translate(1694.145 433.62)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_27007",
    "data-name": "Grupo 27007"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32512",
    "data-name": "Caminho 32512",
    d: "M19.62,6.86,17.14,4.38,6,15.52V18H8.48ZM17.14,5.79l1.07,1.07-1,1L16.14,6.8ZM7,17V15.93L15.43,7.5,16.5,8.57,8.07,17Zm14,2v1H4V19Z",
    fill: "#005288",
    stroke: "#005289",
    strokeWidth: 0.3
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaneta);
export default __webpack_public_path__ + "static/media/caneta.39f797610b1534fe84bb891efbd0725b.svg";
export { ForwardRef as ReactComponent };